import Vue from 'vue'
import vueRouter from 'vue-router'
import NProgress from 'nprogress'
import staticRoutes from './staticRoute'
import whiteRoutes from './whiteRoute'
import { Message } from 'element-ui'
import store from '../store'
import Cookie from 'js-cookie'
import axios from 'axios'
Vue.use(vueRouter)

const router = new vueRouter({
    mode: 'hash',
    routes: staticRoutes
})

const originalPush = vueRouter.prototype.push;
vueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

// 路由跳转前验证
router.beforeEach((to, from, next) => {
    // 开启进度条
    NProgress.start();
    // 判断用户是否处于登录状态
    // console.log('cookieLogin',Cookie.get('loginState'));
    if (Cookie.get('loginState') == 1) {
		let userInfo = JSON.parse(store.state.user.userInfo);
        // 如果当前处于登录状态，并且跳转地址为login，则自动跳回系统首页
        // 这种情况出现在手动修改地址栏地址时
        if (to.path === '/login') {
            next({path: "/home", replace: true})
        } else if(to.path.indexOf("/error") >= 0){
            // 防止因重定向到error页面造成beforeEach死循环
            next()
        } 
        else {
			// 验证访问权限
			if(to.path == '/home'){
				next();
			}else{
				console.log('topath',to.path);
				axios({
					url:store.state.auth.HOST+'/admin.index/checkPath',
					method:'POST',
					data:{
						adminid:userInfo.id,
						token:userInfo.token,
						path:to.path
					}
				})
				.then(res=>{
					console.log(res.data);
					// next({path: "/home", replace: true})
					if(res.data.status == 1){
						next()
					}else{
						next({path: "/error/401", replace: true})
					}
				})
				.catch(err=>{
					console.log(err);
					next({path: "/", replace: true})
				})
			}
			
			next()
			
        }
        // 
		next();
    } else {
        // 如果是免登陆的页面则直接进入，否则跳转到登录页面
        if (whiteRoutes.indexOf(to.path) >= 0) {
            console.log('该页面无需登录即可访问')
            next()
        } else {
            console.log('当前未处于登录状态，请登录')
            next({path: "/login", replace: true})
            // 如果store中有token，同时Cookie中没有登录状态
            // if(!store.state.user.loginToken){
            //     Message({
            //         message: '登录超时，请重新登录'
            //     })
            // }
            // NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done(); // 结束Progress
})

export default router